import styled from 'styled-components';
import theme from 'src/theme';

export const RotationMsgWrapper = styled.div`
    padding: 8px 15px 0 20px;
    cursor: pointer;
`;

export const RotationMsgLeftWrapper = styled.div`
    text-align: center;
`;

export const ExclamationTriangleIcon = styled.div`
    font-size: 1.25rem;
    svg {
        color: ${theme.legacyColors.error};
    }
`;
